import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import { type AllTableCriteria, CriteriaDimension } from '@openx/types/tableCriteria.ts';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { ProvidersListCriteria, ProvidersListFilters } from '../types.ts';

type ProvidersTopBarProps = {
  onChange: (filters: ProvidersListCriteria) => void;
  criteria: AllTableCriteria<ProvidersListFilters>;
};

export const ProvidersTopBar = ({ criteria, onChange }: ProvidersTopBarProps) => {
  const { t } = useTranslation();

  const handleFiltersChange = useCallback(
    (newFilters: ProvidersListFilters) => {
      onChange({
        dimension: CriteriaDimension.FILTERS,
        value: newFilters,
      });
    },
    [onChange]
  );

  return (
    <TopBar
      filters={criteria.filters as ProvidersListFilters}
      onChange={handleFiltersChange}
      searchText={t('Search Name or ID')}
    />
  );
};
